import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { PlatformSharedModule } from '@ecap3/app-shared-module';
import { PlatformConfirmDialogModule } from '@ecap3/app-platform-confirm-dialog';

import { PlatformCalendarComponent } from './components/platform-calendar/platform-calendar.component';
import { PlatfromCalendarEventFormDialogComponent } from './components/event-form/event-form.component';
import { PlatfromCalendarService } from './services/platform-calendar.service';
import { LOCALE_ID } from '@angular/core';
import localeFr from '@angular/common/locales/fr';
import localeDe from '@angular/common/locales/de';
import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MultiTranslateHttpLoader } from '@ecap3/core';
import { CustomCalendarWeeklyDatePipe } from './pipes/custom-calendar-date.pipe';
import { genericHttpLoaderFactory } from 'src/app/shared/providers/delta-uilm-provider';
registerLocaleData(localeFr, 'fr-FR');
registerLocaleData(localeDe, 'de-DE');
registerLocaleData(localeIt, 'it-IT');


@NgModule({
    imports: [
        PlatformConfirmDialogModule,
        PlatformSharedModule,
        ColorPickerModule,
        MatInputModule,
        FormsModule,
        MatToolbarModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatChipsModule,
        MatDividerModule,
         CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        }),
        MatDatepickerModule,
        MatIconModule,
        FlexLayoutModule.withConfig({
            useColumnBasisZero: false,
            printWithBreakpoints: [
                'xs',
                'sm',
                'md',
                'lg',
                'xl',
                'lt-sm',
                'lt-md',
                'lt-lg',
                'lt-xl',
                'gt-xs',
                'gt-sm',
                'gt-md',
                'gt-lg'
            ]
        }),
        RouterModule,
        MatButtonModule,
        CommonModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: genericHttpLoaderFactory(['generic-app']),
                deps: [HttpClient]
            },
            isolate: true
        }),
        MatProgressBarModule,
        MatProgressSpinnerModule
    ],
    exports: [PlatformCalendarComponent],
    declarations: [
        PlatformCalendarComponent,
        PlatfromCalendarEventFormDialogComponent,
        CustomCalendarWeeklyDatePipe
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'fr-FR' },
        { provide: LOCALE_ID, useValue: 'de-DE' },
        { provide: LOCALE_ID, useValue: 'it-IT' },
        { provide: LOCALE_ID, useValue: 'en-EN' },
        PlatfromCalendarService
    ]
})
export class PlatformCalendarModule {}
